import {
  DEFAULT_MULTI_VALUE_COLOR_SCHEME,
  MULTI_VALUE_COLOR_SCHEMES,
} from "@src/components/ui-kit/budget-path-select/constants";
import type { MultiValueColorScheme } from "@src/components/ui-kit/budget-path-select/types";
import type { IOption } from "@src/components/ui-kit/Select/types";

export function getTagCode(option: IOption): string {
  if ("tagCode" in option && typeof option.tagCode === "string") {
    return option.tagCode;
  }

  return option.label.split(" - ")[0] ?? option.label;
}

export function getTagSuffix(option: IOption): string | undefined {
  if ("tagSuffix" in option && typeof option.tagSuffix === "string") {
    return option.tagSuffix;
  }

  const [, ...suffixParts] = option.label.split(" - ");
  const suffix = suffixParts.join(" - ");

  return suffix || undefined;
}

export function getTagColorSchemeByIndex(index: number): MultiValueColorScheme {
  return MULTI_VALUE_COLOR_SCHEMES[index] ?? DEFAULT_MULTI_VALUE_COLOR_SCHEME;
}

export function getSelectedTagIndex(
  selectedValue: string,
  selectedOptions: IOption[],
): number {
  return selectedOptions.findIndex((option) => option.value === selectedValue);
}

export function toScopedValue(
  prefix: "brand" | "project" | "budget-item",
  value: string,
): string {
  return `${prefix}:${value}`;
}
